// Module
var code = `<select
  ng-model="\$ctrl.value"
  ng-required="\$ctrl.required"
  ng-options="o.value as o.label for o in \$ctrl.days">
</select>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/day-of-week/day-of-week.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;